import { render, staticRenderFns } from "./PracticeImitateStart.vue?vue&type=template&id=5274e076&scoped=true"
import script from "./PracticeImitateStart.vue?vue&type=script&lang=js"
export * from "./PracticeImitateStart.vue?vue&type=script&lang=js"
import style0 from "./PracticeImitateStart.vue?vue&type=style&index=0&id=5274e076&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5274e076",
  null
  
)

export default component.exports